var exports = {
  "Yt": "Product__JCupxb",
  "VS": "Background__x8lac6",
  "Zr": "FirstElement__WuwIpX",
  "UC": "Content__TWy-bF",
};

module.exports = exports;
